// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.background {
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -5;
  height: 100%;
  overflow: auto;
  background: #f5f5f5;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.background.app-background {
  background: var(--app-background);
  background-position: center;
}

.background.inital {
  z-index: 100000;
}

.background.blank {
  background: #fff;
}

.background.template_background {
  background: var(--app-background);
}

.loading {
  position: absolute;
  width: 100%;
  height: -webkit-fill-available;
  z-index: 250;
  top: 0;
}

.loading app-loading {
  top: 250px;
  position: absolute;
  text-align: center;
  width: 100%;
}

.loading-icon {
  position: absolute;
  width: 100%;
  z-index: 51;
  text-align: center;
  padding-top: 200px;
}

.offline-box {
  position: absolute;
  z-index: 54;
  left: 40%;
  background: white;
  font-size: 2rem;
  margin-right: 0;
}
.offline-box ion-card {
  width: 90%;
  margin: 20px auto;
  padding: 5px;
  text-align: center;
}
.offline-box ion-card div {
  margin: 5px 0;
}

.loading-icon ion-spinner {
  width: 100px;
  height: 100px;
}

.loading-background {
  height: -webkit-fill-available;
  background: #656565;
  opacity: 0.4;
  position: absolute;
  z-index: 53;
  width: 100%;
}

.loading-icon .spinner-md-crescent circle {
  stroke: #ac1f25;
}

.global {
  background-position: inherit;
}

.main {
  background-size: cover;
}`, "",{"version":3,"sources":["webpack://./src/core/components/app-background/app-background.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EAEA,mBAAA;EAIA,sBAAA;EACA,4BAAA;EACA,2BAAA;AAHF;;AAMA;EACE,iCAAA;EACA,2BAAA;AAHF;;AAMA;EACE,eAAA;AAHF;;AAMA;EACE,gBAAA;AAHF;;AAMA;EACE,iCAAA;AAHF;;AAMA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EACA,YAAA;EACA,MAAA;AAHF;;AAOA;EACE,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AAJF;;AAOA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AAJF;;AAOA;EAEE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;AALF;AAOE;EACE,UAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;AALJ;AAOI;EACE,aAAA;AALN;;AAUA;EACE,YAAA;EACA,aAAA;AAPF;;AAUA;EACE,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;AAPF;;AAUA;EACE,eAAA;AAPF;;AAUA;EACE,4BAAA;AAPF;;AAUA;EACE,sBAAA;AAPF","sourcesContent":[".background {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: -5;\n  height: 100%;\n  overflow: auto;\n\n  background: #f5f5f5;\n\n  //opacity: 0.9;\n\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center\n}\n\n.background.app-background {\n  background: var(--app-background);\n  background-position: center;\n}\n\n.background.inital {\n  z-index: 100000;\n}\n\n.background.blank {\n  background: #fff;\n}\n\n.background.template_background {\n  background: var(--app-background);\n}\n\n.loading {\n  position: absolute;\n  width: 100%;\n  height: -webkit-fill-available;\n  z-index: 250;\n  top: 0;\n  //text-align: center;\n}\n\n.loading app-loading {\n  top: 250px;\n  position: absolute;\n  text-align: center;\n  width: 100%;\n}\n\n.loading-icon {\n  position: absolute;\n  width: 100%;\n  z-index: 51;\n  text-align: center;\n  padding-top: 200px;\n}\n\n.offline-box {\n\n  position: absolute;\n  z-index: 54;\n  left: 40%;\n  background: white;\n  font-size: 2rem;\n  margin-right: 0;\n\n  ion-card {\n    width: 90%;\n    margin: 20px auto;\n    padding: 5px;\n    text-align: center;\n\n    div {\n      margin: 5px 0;\n    }\n  }\n}\n\n.loading-icon ion-spinner {\n  width: 100px;\n  height: 100px;\n}\n\n.loading-background {\n  height: -webkit-fill-available;\n  background: #656565;\n  opacity: 0.4;\n  position: absolute;\n  z-index: 53;\n  width: 100%;\n}\n\n.loading-icon .spinner-md-crescent circle {\n  stroke: #ac1f25;\n}\n\n.global {\n  background-position: inherit;\n}\n\n.main {\n  background-size: cover;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
